import { Component } from '@angular/core';
import {
    AlertController, Events, IonicPage, Loading, LoadingController, NavController, NavParams, Platform,
    Toggle
} from 'ionic-angular';
import {InitMoodTrackerPage} from "../init-mood-tracker/init-mood-tracker";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {ApiStepCounterProvider} from "../../providers/api-step-counter/api-step-counter";
import {InitWizardProvider} from "../../providers/init-wizard/init-wizard";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {ApiInitProvider} from "../../providers/api-init/api-init";
import {AppPartnerSelectionPopupPage} from "../app-partner-selection-popup/app-partner-selection-popup";
import {StepCounterEngineProvider} from "../../providers/step-counter-engine/step-counter-engine";

/**
 * Generated class for the InitStepCounterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-init-step-counter',
  templateUrl: 'init-step-counter.html',
})
export class InitStepCounterPage {

  stepCounter: string = '';
  switchInProgress: boolean = false;
  errorVisible: boolean = false;
  loader: Loading;
  healthkitAvailable: boolean = false;
  shealthAvailable: boolean = false;
  huaweiAvailable: boolean = false;
  firstLoaded: boolean = false;

  resumeSubscriber: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public apiStepCounter: ApiStepCounterProvider, public platform: Platform, public initWizard: InitWizardProvider, public state: UserStateProvider, public event: Events, public apiAuth: ApiAuthProvider, public apiInit: ApiInitProvider, public stepCounterEngineProvider: StepCounterEngineProvider) {
    console.log(this.navParams);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InitStepCounterPage >31');

    console.log(this.navParams);

    if(this.state.user.stepCounterEngine) {
      this.initWizard.stepCounterEngine = this.state.user.stepCounterEngine;
    }

    if(this.navParams.get('success') && this.navParams.get('provider')) {
      this.initWizard.stepCounterEngine = this.navParams.get('provider');
    }

    if(this.initWizard.stepCounterEngine) {
      this.stepCounter = this.initWizard.stepCounterEngine;
    }

    if((window as any).plugins && (window as any).plugins.healthkit) {
      var me = this;
      (window as any).plugins.healthkit.available(function() {
        me.healthkitAvailable = true;
      })
    }

    // if((window as any).shealth) {
    //   var me = this;
    //   (window as any).shealth.initialize(function() {
    //     me.shealthAvailable = true;
    //   })
    // }

    if((window as any).huawei_health) {
      var me = this;
      (window as any).huawei_health.initialize(function() {
        me.huaweiAvailable = true;
      })
    }

    this.resumeSubscriber = function() {
      me.apiAuth.tryToRefreshSession().then(user => {
        me.switchInProgress = false;
        me.stepCounter = user.user.stepCounterEngine
        me.initWizard.stepCounterEngine = user.user.stepCounterEngine;

        if(me.loader) {
          me.loader.dismissAll();
        }
      })
    }

    this.event.subscribe('app:resumed', this.resumeSubscriber)

  }

  ionViewWillLeave() {
    console.log('ionViewWillLeave InitStepCounterPage');
    if(this.loader) {
      this.loader.dismissAll();
    }

    this.event.unsubscribe('app.resumed', this.resumeSubscriber);
  }

  initializeSwitch(item: Toggle, provider: string) {

    console.log('initializeSwitch', item, provider, console.log(item.checked));

    this.errorVisible = false;
    if(!item.checked) {
      if(provider == this.stepCounter) {
        this.stepCounter = null;
      }
      //item was unchecked - nothing to do
      return false;
    }

    if(!this.firstLoaded) {
      this.firstLoaded = true;
      if(this.navParams.get('provider') == provider) {
        return ;
      }
      if(this.initWizard.stepCounterEngine == provider) {
        return ;
      }
    }

    this.stepCounter = provider;

    var me = this;
    let iloader = this.loadingCtrl.create();
    iloader.present();
    this.loader = iloader;

    if(provider == 'healthkit') {
      if((window as any).plugins && (window as any).plugins.healthkit) {
        (window as any).plugins.healthkit.requestAuthorization({readTypes: ['HKQuantityTypeIdentifierStepCount']}, function() {
          me.apiStepCounter.createSession(provider).then((success) => {
            me.stepCounter = provider;
            iloader.dismissAll();
          }, (err) => {
            iloader.dismissAll();
            me.stepCounter = null;
            item.checked = false;
          })
        }, function() {
          iloader.dismissAll();
          me.stepCounter = null;
          item.checked = false;
        });
      }

      return false;
    }

    if(provider == 'huawei') {
      me.stepCounterEngineProvider.getEngine('huawei').syncAvailable().then((res) => {
        console.log('syncAvailable', res)
        me.apiStepCounter.createSession(provider).then((success) => {
          me.stepCounter = provider;
          iloader.dismissAll();
        }, (err) => {
          iloader.dismissAll();
          me.stepCounter = null;
          item.checked = false;
        })
      }).catch(() => {
        iloader.dismissAll();
        me.stepCounter = null;
        item.checked = false;
      });

      return ;
    }

    me.apiStepCounter.createSession(provider).then((success) => {
      me.stepCounter = provider;
      me.switchInProgress = false;
      iloader.dismissAll();
    }, (err) => {
      iloader.dismissAll();
      me.switchInProgress = false;
      item.checked = false;
      me.stepCounter = null;
      iloader.dismissAll();
    })

    setTimeout(function() {
      if(me.platform.is('mobileweb') || me.platform.is('core')) {
        iloader.dismissAll();
        me.stepCounter = provider;
      }
    }, 100);




    /*setTimeout(function() {
      var result = Math.round(Math.random());
      console.log(result);
      if(result == 1) {
        me.stepCounter = provider;
      } else {
        item.checked = false;
      }

      setTimeout(function() {
        loader.dismissAll();
        me.switchInProgress = false;
      }, 10);
    }, 1000);*/
  }

  storeProvider() {
    this.state.user.stepCounterEngine = this.stepCounter;
    this.event.publish('app:step-counter-engine-update');
    this.navCtrl.pop();
  }

  nextStep() {
    if(!this.stepCounter) {
      this.errorVisible = true;
    } else {
      this.storeProvider();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/init-step-counter/init-step-counter.ts